import { render, staticRenderFns } from "./resetPw_en.vue?vue&type=template&id=3cf4d98e&"
import script from "./resetPw_en.vue?vue&type=script&lang=js&"
export * from "./resetPw_en.vue?vue&type=script&lang=js&"
import style0 from "./resetPw_en.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports